import LoadElement from "../../classes/load/LoadElement";

export default class ConcentratedLoadElement extends LoadElement {
  constructor(id, name, force, lengthL1, parentID) {
    super(id, name, force, lengthL1, parentID);
    this.classType="ConcentratedLoadElement";
  }
}
